import Airport from './Airport';

export default Airport;
